import { IAPI_URL } from '../circulusConfig';

const apiFetch = async (path, params = {}) => {
  const url = new URL(`${IAPI_URL}${path}`);
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') url.searchParams.set(k, v);
  });
  const res = await fetch(url.toString());
  if (!res.ok) throw new Error(`[HTTP ERROR] ${res.status}`);
  const json = await res.json();
  return json.data;
};

const apiPatch = async (path, body) => {
  const res = await fetch(`${IAPI_URL}${path}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(`[HTTP ERROR] ${res.status}`);
  return res.json();
};

export const getHwListAPI = (userId) =>
  apiFetch('hw/list', { userId });

export const getInteractionCountAPI = (userId) =>
  apiFetch('interaction/count', { userId });

export const getInteractionStatAPI = (userId, start, end) =>
  apiFetch('interaction/stat', { userId, start, end });

export const getFeatureCountAPI = (userId, start, end) =>
  apiFetch('feature/count', { userId, start, end });

export const getInteractionHourlyStatAPI = (userId) =>
  apiFetch('interaction/hourly', { userId });

export const getPerformanceSummaryAPI = (userId, start, end) =>
  apiFetch('interaction/performance-summary', { userId, start, end });

export const getEmotionSummaryAPI = (userId) =>
  apiFetch('interaction/emotion-summary', { userId });

export const updateSubUserNickNameAPI = (userId, nickName) =>
  apiPatch('sub_user', { userId, nickName });
